import { useBanner, useManageCreditAccountPageRightPanel } from 'src/hooks';
import styles from './AddOnContainer.module.scss';
import cn from 'classnames';
import { AddOnPanel } from '../AddOnPanel';
import { ManageCreditAccountRightSidePanelType } from 'src/types';
import { useRef, useState } from 'react';
import { CreditsCheckout } from 'src/v2/pages/subscription/components/CreditsCheckout';
import { AppearingFromRight } from 'src/animations/AppearingFromRight';
import { LoadingOverlay } from 'src/pages/PaymentBetaPage/components/LoadingOverlay';
import { CreditsPaymentMethodUpdate } from 'src/v2/pages/subscription/components/CreditsPaymentMethodUpdate';

interface AddOnContainerProps {
  children: JSX.Element;
  className?: string;
}

export const AddOnContainer = ({
  children,
  className,
}: AddOnContainerProps) => {
  const [isPaymentProcessing, setPaymentProcessing] = useState<boolean>(false);
  const [isPaymentUpdateProcessing, setPaymentUpdateProcessing] =
    useState<boolean>(false);

  const checkoutContentRef = useRef<HTMLDivElement>(null);

  const { activePanelView, changeActivePanelView } =
    useManageCreditAccountPageRightPanel();
  const { bannersSet } = useBanner();

  const handleCloseRightSidePanel = () => {
    changeActivePanelView(null);
  };

  const renderRightSideContent = () => {
    switch (activePanelView) {
      case ManageCreditAccountRightSidePanelType.ManageCredits:
        return (
          <CreditsCheckout
            onClose={handleCloseRightSidePanel}
            onPaymentProcessing={setPaymentProcessing}
          />
        );
      case ManageCreditAccountRightSidePanelType.UpdatePaymentMethod:
        return (
          <CreditsPaymentMethodUpdate
            onClose={handleCloseRightSidePanel}
            onUpdatePaymentProcessing={setPaymentUpdateProcessing}
          />
        );
      default:
        return <div className={styles.defaultContainer} />;
    }
  };

  return (
    <div className={cn(styles.root, className)}>
      {(isPaymentProcessing || isPaymentUpdateProcessing) && (
        <LoadingOverlay
          label={`Processing ${isPaymentUpdateProcessing ? 'update' : 'payment'}...`}
        />
      )}

      <div className={styles.container}>
        <AddOnPanel />

        <div
          className={cn(styles.section, {
            [styles.expandPadding]: bannersSet.length !== 0,
          })}
        >
          {children}
        </div>
      </div>

      <AppearingFromRight
        width={320}
        inProp={!!activePanelView}
        nodeRef={checkoutContentRef}
        enableTabletMode={false}
      >
        {renderRightSideContent()}
      </AppearingFromRight>
    </div>
  );
};
